import React from "react";
import { NavLink } from "react-router-dom";

const BreadComps = ({ title0, link0, title1, link1, title2, link2, activetitle }) => {
    return (
        <div className="myaccountBreadcomp">
            <NavLink to="/" className="Myaccounthome-title text-decoration-none">Home</NavLink>
            {title0 && (
                <>
                    <div className="myaccount-breadcomp-slash">/</div>
                    <NavLink to={`/categories/${link0}`} className="Myaccounthome-title text-decoration-none">{title0}</NavLink>
                </>
            )}
            {title1 && (
                <>
                    <div className="myaccount-breadcomp-slash">/</div>
                    <NavLink to={`/products-category/${link1}`} className="Myaccounthome-title text-decoration-none">{title1}</NavLink>
                </>
            )}
            {title2 && (
                <>
                    <div className="myaccount-breadcomp-slash">/</div>
                    <NavLink to={`/products-subcategory/${link1}/${link2}`} className="Myaccounthome-title text-decoration-none">{title2}</NavLink>
                </>
            )}
            <div className="myaccount-breadcomp-slash">/</div>
            <div className="myaccountbreadcomp-activetitle">{activetitle}</div>
        </div>
    );
};

export default BreadComps;
